import React from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import Text from "../../../utils/Custom/text";
import { ClassicTable } from "../clientMaster/ClassicTable";

const IRImageUpload = ({ label, images, setImages, PrintView }) => {
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const data = new FormData();
    data.append("fileToUpload", file);

    try {
      const res = await axiosWithToken.post(
        BASE_URL + "fileUpload/fileUpload.php",
        data
      );
      if (res.status === 200) {
        setImages((prev) => [
          ...prev,
          {
            imagePath: res.data,
            imagesName: "",
          },
        ]);
      }
    } catch (err) {
      console.error("Image Upload Failed", err);
    }
  };

  const handleImageNameChange = (index, value) => {
    const updated = [...images];
    updated[index].imagesName = value;
    setImages(updated);
  };

  const handleImageDelete = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    setImages(updated);
  };

  return (
    <div className="mb-6">
      <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 my-5">
        {label}
      </Text>

      {!PrintView && (
      <div className="flex justify-end">
        <input
          id="image-upload"
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{ display: "none" }}
        />
        <label htmlFor="image-upload">
          <Button variant="contained" component="span" size="small">
            Upload Image
          </Button>
        </label>
      </div>
      )}

      {images.length > 0 && (
        <ClassicTable className="mt-4">
          <Table sx={{ minWidth: 660 }}>
            <TableHead>
              <TableRow>
                <TableCell>Sr.No</TableCell>
                <TableCell>Image Name</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {images.map((img, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      value={img.imagesName || ""}
                      onChange={(e) =>
                        handleImageNameChange(index, e.target.value)
                      }
                      fullWidth
                      disabled={PrintView}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      component="a"
                      href={img.imagePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="success"
                    >
                      <PreviewIcon />
                    </IconButton>
                    {!PrintView && (
                    <IconButton onClick={() => handleImageDelete(index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ClassicTable>
      )}
    </div>
  );
};

export default IRImageUpload;
